import { defineMessages } from 'react-intl';

const messages = defineMessages({
    elementsModalCloseText: {
        id:'elementsModalCloseText',
        defaultMessage: 'Close',
        description: 'Text for the modal dialog close button',
    },
    elementsModalBackText: {
        id:'elementsModalBackText',
        defaultMessage: 'Back',
        description: 'Text for the modal dialog back button',
    },
});

export default messages;
